import { BracketsEllipses } from "@hl/base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import {
  Button,
  Group,
  SelectProps,
  Stack,
  Text,
  Input,
  InputWrapperProps,
  Box,
} from "@mantine/core";
import BoxContainer from "~/../../base-components/lib/BoxContainer";
import { TEXT_COLOR } from "~/../../base-components/lib/theme/colors";

import { Contract2, _CollectionType } from "apollo/graphql.generated";

import ContractSelect from "./ContractSelect";
import { transform } from "./CreateContractModal";

type SelectContractDropdownProps = {
  collectionType: _CollectionType;
  contractId: string | null;
  contractOnChange: (contractId: string | null) => void;
  newContract: {
    type: "new";
    edited: boolean;
    data: {
      name: string;
      symbol: string;
      usingOpenseaBlocklist: boolean;
    };
  };
  contracts?: Contract2[];
  handleCreate: () => void;
  hasError: boolean;
} & Omit<SelectProps, "data">;

const SelectContractDropdown = ({
  collectionType,
  contractId,
  contractOnChange,
  handleCreate,
  contracts,
  newContract,
  hasError,
  ...rest
}: SelectContractDropdownProps) => {
  const NoExistingContracts = (
    props: Pick<InputWrapperProps, "label" | "description">
  ) => {
    return (
      <Input.Wrapper {...props}>
        <BoxContainer mt={8} p="12px 16px" error={hasError}>
          <Group position="apart" noWrap>
            <Group miw={0} noWrap>
              <Box miw={20}>
                <BracketsEllipses />
              </Box>
              <Stack spacing={0} miw={0}>
                <Group position="left" spacing={4} noWrap>
                  <Text
                    size="sm"
                    sx={{
                      minWidth: 0,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {newContract.data.name}
                  </Text>
                  <Text size="sm">·</Text>
                  <Text size="sm" fw={500}>
                    New
                  </Text>
                </Group>
                <Text size="sm" color={TEXT_COLOR.SECONDARY}>
                  {transform(collectionType)} (ERC-721)
                </Text>
              </Stack>
            </Group>
            <Button
              color={SECONDARY_COLOR}
              onClick={handleCreate}
              px="sm"
              size="xs"
            >
              {newContract.edited ? "Edit" : "Customize"}
            </Button>
          </Group>
        </BoxContainer>
      </Input.Wrapper>
    );
  };

  if (
    (collectionType === _CollectionType.LimitedEdition ||
      collectionType === _CollectionType.OneOfOne) &&
    contracts?.length
  ) {
    return (
      <ContractSelect
        contracts={contracts}
        contractId={contractId}
        contractOnChange={contractOnChange}
        newContract={newContract}
        handleCreate={handleCreate}
        {...rest}
      />
    );
  }

  return <NoExistingContracts {...rest} />;
};

export default SelectContractDropdown;
